import React, { Component } from 'react';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { GroupSelectOption } from '~/ProductGroupSelect';
import ActivityIndicator from '~/UI/ActivityIndicator';
import SegmentedSelectOption from '~/UI/SegmentedSelect/Option/SegmentedSelectOption';
import SegmentedSelectPage from '~/UI/SegmentedSelect/Page/SegmentedSelectPage';
import SegmentedSelectSegment from '~/UI/SegmentedSelect/Segment/SegmentedSelectSegment';
import { SelectedOption } from '~/UI/SegmentedSelect/SegmentedSelect';

import styles from './styles.less';

interface Props {
	nameFilter: string;
	groups: UserProductGroup[];
	isFetching: boolean;
	hasMore: boolean;
	selectedOption: SelectedOption | null;
	onFetch(nameFilter: string): void;
	onSelect(selectedOption: SelectedOption): void;
}

export default class FolderSelect extends Component<Props> {
	componentDidUpdate(prevProps: Props) {
		const { nameFilter, onFetch } = this.props;

		if (nameFilter !== prevProps.nameFilter) {
			onFetch(nameFilter);
		}
	}

	renderOptions(groups: UserProductGroup[], displayModule: boolean) {
		return groups.map((group) => (
			<SegmentedSelectOption disableAutoScroll key={group.id} prompt={group.name} value={group}>
				<GroupSelectOption displayModule={displayModule} group={group} />
			</SegmentedSelectOption>
		));
	}

	handleSelect = (option: { index: number; segmentIndex: number; option: React.ReactNode } | null) => {
		this.props.onSelect({
			// @ts-expect-error hacking of react
			value: option?.option?.props.value,
			parentValue: null,
			prompt: null,
		});
	};

	render() {
		const { nameFilter, groups, selectedOption, isFetching, hasMore, onFetch } = this.props;

		return (
			<div className={styles.container}>
				<SegmentedSelectPage
					hasMore={hasMore}
					selectedOption={selectedOption}
					styles={styles}
					onFetch={() => onFetch(nameFilter)}
					onSelect={this.handleSelect}
				>
					<SegmentedSelectSegment>{this.renderOptions(groups, true)}</SegmentedSelectSegment>
				</SegmentedSelectPage>

				{isFetching ? <ActivityIndicator /> : null}
			</div>
		);
	}
}
